/**
 * Dale's map points: a classic map pin, a drop in Dale's sunset that points at
 * the place, with a cream dot; the selected one becomes the Dale mark, the dark
 * D on sunset. The button is wider than the drop so the touch target stays
 * generous; its bottom edge is the tip, so markers anchor at the bottom.
 * Styles live in map.css.
 */

const GLYPH_PATH = 'M380 252L476 252A256 216 0 0 1 476 684L402 684L303.91 764.57Q290 776 295.03 758.72L336 618L336 296A44 44 0 0 1 380 252ZM446 348L476 348A160 120 0 0 1 476 588L448 588A16 16 0 0 1 432 572L432 362A14 14 0 0 1 446 348ZM482 468A62 62 0 1 0 606 468A62 62 0 1 0 482 468Z';

const DROP = `<svg class="dale-pin-drop" viewBox="0 0 40 54" aria-hidden="true">
<defs><linearGradient id="dale-pin-fill" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#F6AE78"/><stop offset=".55" stop-color="#F09B5C"/><stop offset="1" stop-color="#E88B4C"/></linearGradient></defs>
<path class="dale-pin-body" d="M20 52.6C20 52.6 3 34.2 3 20A17 17 0 0 1 37 20C37 34.2 20 52.6 20 52.6Z"/>
<circle class="dale-pin-dot" cx="20" cy="20" r="6.4"/>
<svg class="dale-pin-glyph" x="10.4" y="8.6" width="19.2" height="22.2" viewBox="270 230 490 565"><path fill="#1C1005" fill-rule="evenodd" d="${GLYPH_PATH}"/></svg>
</svg>`;

/** The pin's tip is the bottom edge of the element: hand this to MapLibre's Marker. */
export const PIN_ANCHOR = 'bottom' as const;

export type PinOptions = { label: string; selected?: boolean; owner?: boolean };

/** A new pin element; the caller wires clicks and hands it to a MapLibre Marker. */
export function createPinElement({ label, selected = false, owner = false }: PinOptions): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'dale-pin';
  button.setAttribute('aria-label', label);
  if (owner) button.dataset.owner = 'true';
  button.innerHTML = DROP;
  setPinSelected(button, selected);
  return button;
}

export function setPinSelected(pin: HTMLElement, selected: boolean): void {
  pin.setAttribute('aria-pressed', String(selected));
}
